import RemoveCircle from "@material-ui/icons/RemoveCircle";

import Table from "src/components/Table";
import { listAllAdmins_listAdmins } from "src/graphql/generated/listAllAdmins";

export default function OrgOwnerTable({
  rows,
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  totalCount,
  handleRemoveOwner
}: {
  rows: listAllAdmins_listAdmins[];
  page: number;
  handleChangePage: (newPage: number) => void;
  rowsPerPage: number;
  handleChangeRowsPerPage: (newRowsPerPage: number) => void;
  totalCount: number;
  handleRemoveOwner: (owner: listAllAdmins_listAdmins) => void;
}): JSX.Element {
  return (
    <Table
      columns={[
        {
          key: "fillname",
          title: "Full Name",
          renderValue: admin => admin.fullName
        },
        {
          key: "createdAt",
          title: "Invited At",
          renderValue: admin => new Date(admin.createdAt).toLocaleString()
        },
        {
          key: "email",
          title: "Email",
          renderValue: admin => admin.email
        }
      ]}
      rows={rows}
      rowActions={[
        {
          icon: <RemoveCircle />,
          tooltipLabel: "Remove Organization Owner",
          onClick: owner => handleRemoveOwner(owner)
        }
      ]}
      emptyState="No organization owners found"
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      page={page}
      onChangePage={handleChangePage}
    />
  );
}
